import { GetterTree } from 'vuex';
import { IMenuSearchState, ILookupResult } from './types';

const getters: GetterTree<IMenuSearchState, any> = {
  lookup(state): string {
    return state.lookup;
  },
  results(state): ILookupResult[] {
    return state.results;
  },
  selectedResultIndex(state): number {
    return state.selectedResultIndex;
  },
  selectedResult(state): ILookupResult | null {
    return state.results[state.selectedResultIndex];
  },
  cacheSuffix(state): string {
    return state.cacheSuffix;
  },
  mustHaveCacheSuffix(state): boolean {
    return state.mustHaveCacheSuffix;
  },
  isSearching(state): boolean {
    return state.isSearching;
  },
};

export default getters;
